/* eslint react/prop-types: 0 */
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import 'build-and-quote/components/Summary/components/VehicleSpecs/VehicleSpecs.scss';

const VehicleSpecs = ({
    CityFuelConsumption,
    HighwayFuelConsumption,
    selectedDriveTrain,
    selectedEngine,
    selectedTransmission,
    selectedOptionsPackageExteriorColor,
    selectedOptionsPackageInteriorColor,
    odometer,
}) => {
    return (
        <div className="car-specs">
            <h2 className="specs-title sr-subtitle-2">{LocaleService.t('summarySection.specs_title')}</h2>
            {selectedDriveTrain && (
                <div className="specs-bloc">
                    <icon className="icon-Front-Wheel-Drive" />
                    <div className="specs-bloc--content">{selectedDriveTrain}</div>
                </div>
            )}
            {selectedEngine && (
                <div className="specs-bloc">
                    <icon className="icon-engine" />
                    <div className="specs-bloc--content">
                        {selectedEngine}
                        {/*
                        DATA MISSING to display engine torque and horse power
                        ----------------------------------
                        {LocaleService.t(selectedDrivePowerTrain.engine.isTurbo ? 'engine.sizeTurbo' : 'engine.size', {
                            displacement: selectedDrivePowerTrain.engine.displacement,
                            cylinders: selectedDrivePowerTrain.engine.cylinders,
                        })}
                        <span>
                            {LocaleService.t('engine.power', {
                                hp: selectedDrivePowerTrain.engine.hp,
                                torque: selectedDrivePowerTrain.engine.torque,
                            })}
                        </span>
                        ----------------------------------
                        */}
                    </div>
                </div>
            )}
            {selectedTransmission && (
                <div className="specs-bloc">
                    <icon className="icon-transmission" />
                    <div className="specs-bloc--content">
                        {LocaleService.t('transmission.typesSpeeds', {
                            type: selectedTransmission.name,
                            speeds: selectedTransmission.transGears,
                        })}
                        {CityFuelConsumption &&
                            HighwayFuelConsumption && (
                                <span className="fuel-consumption">
                                    {LocaleService.t('summarySection.fuelConsumption', {
                                        CityFuelConsumption,
                                        HighwayFuelConsumption,
                                    })}
                                </span>
                            )}
                    </div>
                </div>
            )}
            {/* DATA MISSING to display Cab Size and Box Size
            ----------------------------------
            {selectedCabSize &&
                selectedBoxSize && (
                    <div className="specs-bloc">
                        <icon className="icon-truck" />
                        <div className="specs-bloc--content">
                            {LocaleService.t('summarySection.CAB_AND_BOX_SIZES', {
                                cabSize: LocaleService.capitalizeTitle(selectedCabSize.description),
                                boxSize: selectedBoxSize.description,
                            })}
                        </div>
                    </div>
                )}
            ----------------------------------
            */}
            {selectedOptionsPackageExteriorColor && (
                <div className="specs-bloc">
                    <div
                        style={{ 'background-color': selectedOptionsPackageExteriorColor?.hexValue || '' }}
                        className={`specs-bloc--color${
                            selectedOptionsPackageExteriorColor?.hexValue ? '' : ' unavailable'
                        }`}
                    />
                    <div className="specs-bloc--content">
                        {LocaleService.t('summarySection.exterior_color_label')}
                        <span>
                            {selectedOptionsPackageExteriorColor.colorDescription ||
                                selectedOptionsPackageExteriorColor.color}
                        </span>
                    </div>
                </div>
            )}
            {selectedOptionsPackageInteriorColor && (
                <div className="specs-bloc">
                    <div
                        style={{ 'background-color': selectedOptionsPackageInteriorColor.hexValue || '' }}
                        className={`specs-bloc--color${
                            selectedOptionsPackageInteriorColor?.hexValue ? '' : ' unavailable'
                        }`}
                    />

                    <div className="specs-bloc--content">
                        {LocaleService.t('summarySection.interior_color_label')}
                        <span>
                            {selectedOptionsPackageInteriorColor.colorDescription ||
                                selectedOptionsPackageInteriorColor.color}
                        </span>
                    </div>
                </div>
            )}
            {odometer > 1 && (
                <div className="specs-bloc">
                    <icon className="icon-odometer" />
                    <div className="specs-bloc--content">
                        {LocaleService.t('summarySection.odometer')}
                        <span>{odometer} km</span>
                    </div>
                </div>
            )}
        </div>
    );
};

VehicleSpecs.propTypes = {
    CityFuelConsumption: PropTypes.number.isRequired,
    HighwayFuelConsumption: PropTypes.number.isRequired,
    selectedDriveTrain: PropTypes.string.isRequired,
    selectedEngine: PropTypes.string.isRequired,
    selectedTransmission: PropTypes.shape({
        name: PropTypes.string,
        transGears: PropTypes.string,
    }).isRequired,
    selectedOptionsPackageExteriorColor: PropTypes.shape({
        colorDescription: PropTypes.string.isRequired,
        hexValue: PropTypes.string,
    }).isRequired,
    selectedOptionsPackageInteriorColor: PropTypes.shape({
        colorDescription: PropTypes.string.isRequired,
        hexValue: PropTypes.string,
    }).isRequired,
    odometer: PropTypes.number.isRequired,
};

VehicleSpecs.displayName = 'VehicleSpecs';

export default VehicleSpecs;
